import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DeleteConfirmDialogComponent } from './components/delete-confirm-dialog/delete-confirm-dialog.component';
import { ImagePreviewDialogComponent } from './components/image-preview-dialog/image-preview-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { ImageUrlPipe } from './pipes/image-url.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GridImageCellComponent } from './components/grid-image-cell/grid-image-cell.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { NumericInputDirective } from './directives/numeric-input.directive';


@NgModule({
  declarations: [
    DeleteConfirmDialogComponent,
    ImagePreviewDialogComponent,
    GridImageCellComponent,
    ConfirmDialogComponent,
    NumericInputDirective
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ImageUrlPipe,
    MatProgressSpinnerModule
  ],
  exports: [
    NumericInputDirective
  ]
})
export class SharedModule { }
